module.exports = __webpack_public_path__ + "img/3CH_Vin.b27e8e62.png";